/* ============================================================
   <spring-related> — "You may also like" horizontal scroller
   Native overflow scroll at every breakpoint; arrows drive
   scrollBy by one card width + gap and reflect start/end state.
   ============================================================ */

class SpringRelated extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[js-spring-related-track]');
    this.arrows = this.querySelector('.spring-related__arrows');
    this.prevBtn = this.querySelector('[js-spring-related-prev]');
    this.nextBtn = this.querySelector('[js-spring-related-next]');

    if (!this.track) return;

    this.bindArrows();
    this.bindScroll();
    this.bindKeyboard();
    this.updateArrows();
  }

  bindArrows() {
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () => this.scrollByDirection(-1));
    }
    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () => this.scrollByDirection(1));
    }
  }

  bindScroll() {
    this.track.addEventListener('scroll', () => this.updateArrows(), { passive: true });
    window.addEventListener('resize', () => this.updateArrows(), { passive: true });
  }

  bindKeyboard() {
    this.track.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') {
        e.preventDefault();
        this.scrollByDirection(1);
      } else if (e.key === 'ArrowLeft') {
        e.preventDefault();
        this.scrollByDirection(-1);
      }
    });
  }

  scrollByDirection(direction) {
    const card = this.track.querySelector('.spring-product-grid__card');
    if (!card) return;

    const cardWidth = card.getBoundingClientRect().width;
    const styles = window.getComputedStyle(this.track);
    const gap = parseFloat(styles.columnGap || styles.gap || '0');
    const step = cardWidth + gap;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.track.scrollBy({
      left: step * direction,
      behavior: reducedMotion ? 'auto' : 'smooth',
    });
  }

  updateArrows() {
    if (!this.prevBtn && !this.nextBtn) return;

    // Hide the arrows entirely when every card already fits (no overflow) —
    // empty string restores the stylesheet's own breakpoint visibility.
    const hasOverflow = this.track.scrollWidth > this.track.clientWidth + 1;
    if (this.arrows) this.arrows.style.display = hasOverflow ? '' : 'none';

    const atStart = this.track.scrollLeft <= 1;
    const atEnd =
      this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 1;

    if (this.prevBtn) this.prevBtn.disabled = atStart;
    if (this.nextBtn) this.nextBtn.disabled = atEnd;
  }
}

if (!customElements.get('spring-related')) {
  customElements.define('spring-related', SpringRelated);
}
